export const tablePro = {
  tablePro: {
    itemsPerPage: '{{count}} per Page',
    noContentMessage: 'No Content Found',
    inputSearchPlaceholder: 'Type here to search...',
    qtyLabel: 'Showing {{start}} to {{end}} of {{total}} results',
    perPage: 'Per Page',
    noContentFound: 'No Content Found',
    typeHereToSearch: 'Type here to search...',
    classContainer: '',
    currentPage: 'Current Page',
    itemsPerPageConfig: 'Items Per Page Config',
    hasItemsPerPageSelector: 'Has Items Per Page Selector',
    hasSearchBox: 'Has Search Box',
    floattingBottom: 'Floating Bottom',
    inputSearch: {
      placeholder: 'Type here to search...',
    },
    collumnConfig: 'Column Configuration',
    currentValue: 'Current Value',
  },
};